var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Actions, Effect, ofType } from '@ngrx/effects';
import { map, switchMap, catchError } from 'rxjs/operators';
import { of } from 'rxjs';
import * as LanguageActions from '../actions/language.action';
import { LanguageActionTypes } from '../actions/language.action';
import { LanguageService } from '@core/service/language.service';
export class LanguageEffects {
    constructor(actions$, languageService) {
        this.actions$ = actions$;
        this.languageService = languageService;
        this.loadSubgroups$ = this.actions$.pipe(ofType(LanguageActionTypes.LanguagesLoad), switchMap(() => {
            return this.languageService.getLanguages().pipe(map(language => new LanguageActions.LanguagesLoadSuccess(language)), catchError(error => of(new LanguageActions.LanguagesLoadFail(error))));
        }));
    }
}
__decorate([
    Effect(),
    __metadata("design:type", Object)
], LanguageEffects.prototype, "loadSubgroups$", void 0);
